import { css } from 'styled-components';

const Header = css`
  font: ${props => props.theme.fontWeightDccc} 14px/16px ${props => props.theme.fontFamilyBody};
  letter-spacing: 0.1px;
  text-transform: uppercase;
`;

const Row = css`
  font: ${props => props.theme.fontWeightBold} 14px/120% ${props => props.theme.fontFamilyBody};
  text-transform: capitalize;
  color: ${props => props.theme.bodyColor};
`;

const Num = css`
  ${Row};
  font-size: 16px;
`;

export {
  Header,
  Row,
  Num,
};
